
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1729477465355",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1646",
    "width": "16",
    "height": "16"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M111.61952 73.728l30.848 15.424q6.848 2.848 120.576 2.848 25.152 0 75.424-1.152t75.424-1.152q40 0 140.864-0.576t174.016-0.288 141.152 2.56q18.848 0.576 32-17.728l24-0.576q2.272 0 8 0.288t8 0.288q1.152 64 1.152 192 0 45.728-2.848 62.272-22.272 8-38.848 10.272-14.272-25.152-30.848-73.152-1.728-5.152-6.272-27.136t-8.576-42.016-4-20.576q-5.728-7.424-15.424-10.848-2.848-1.152-37.728-1.152-17.152 0-53.152-0.576t-58.848-0.576-53.728 1.152-54.848 4q-5.152 46.272-4.576 77.728l0.576 86.848 0-29.728q0 31.424 0.576 88t0.864 102.848 0.288 87.424q0 9.152-1.44 40.864t0 52.288 7.136 39.424q22.848 12 70.848 24.288t68.576 21.44q2.848 22.848 2.848 28.576 0 8-1.728 16.576l-19.424 0.576q-43.424 1.152-124.576-4.576t-118.272-5.728q-28.576 0-86.272 5.152t-86.848 5.152q-1.728-29.152-1.728-29.728l0-5.152q9.728-15.424 35.136-24.576t56.288-16.576 44.576-15.424q4-9.152 6.56-42.272t3.424-83.136 0.864-88.576-0.288-87.712-0.288-50.848q0-4-1.44-12.288t-1.44-12.864q0-4 0.288-25.152t0.576-41.728 0-43.712-1.728-38.56-3.712-18.272q-6.272-6.848-92.576-6.848-23.424 0-93.152 7.712t-78.848 14.016q-10.848 6.848-19.424 40.864t-18.016 63.712-24.288 30.848q-24-14.848-32-25.152l0-218.848zM813.92352 806.272q6.848 0 24 11.136t32.864 23.712 34.016 28 20.576 17.152q14.848 12 14.848 28t-14.848 28q-2.272 1.728-20.576 17.152t-34.016 28-32.864 23.712-24 11.136q-7.424 0-11.712-6.016t-5.728-16.288-1.44-19.136 0.864-18.848 0.864-11.136l-585.152 0q0 1.152 0.864 11.136t0.864 18.848-1.44 19.136-5.728 16.288-11.712 6.016q-6.848 0-24-11.136t-32.864-23.712-34.016-28-20.576-17.152q-14.848-12-14.848-28t14.848-28q2.272-1.728 20.576-17.152t34.016-28 32.864-23.712 24-11.136q7.424 0 11.712 6.016t5.728 16.288 1.44 19.136-0.864 18.848-0.864 11.136l585.152 0q0-1.152-0.864-11.136t-0.864-18.848 1.44-19.136 5.728-16.288 11.712-6.016z",
        "p-id": "1647"
      }
    }
  ]
})
    }
  